import { useMutation, useQueryClient } from '@tanstack/react-query';
import { projectService } from '@services/project';
import { toast } from 'react-toastify';
import { useTranslation } from '@hooks/useTranslation';

export const useDeleteProject = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['deleteProject'],
    mutationFn: async (projectId: string) => {
      return await projectService.deleteProject(projectId);
    },
    onSuccess: (data) => {
      // Invalidate projects lists and current project queries
      queryClient.invalidateQueries({ queryKey: ['projects'] });

      if (data?.affected > 0) {
        toast.success(tActionMessages.projectDeletedSuccessfully);
      } else {
        toast.warning(tActionMessages.noProjectWasDeleted);
      }
    },
    onError: (error: any) => {
      toast.error(
        error?.response?.data?.message ||
          error?.response?.errors?.[0]?.message ||
          error?.message ||
          tActionMessages.failedToDeleteProject,
      );
    },
  });
};

export default useDeleteProject;
